import { useEffect, useRef } from "react";

// Exact URLs applied as CSS backgrounds on PaymentCartHeader so the warmed cache
// entry matches what the browser later requests.
const IMAGE_URLS = [
    "https://media-assets.swiggy.com/portal/static-assets/images/dineout/regular-masthead.png",
    "https://media-assets.swiggy.com/fl_lossy,f_auto,q_auto,w_720,c_limit/portal/static-assets/images/dineout/PS-masthead.png",
];

export const usePrefetchImageAssests = () => {
    const fetchedRef = useRef(false);
    useEffect(() => {
        if (fetchedRef.current) return;
        IMAGE_URLS.forEach((src) => {
            try {
                const image = new Image();
                image.onerror = () => void 0;
                image.src = src;
            } catch {
                // NO OP
            }
        });
        fetchedRef.current = true;
    }, []);
};
